<template>
  <div class="layout-frame container mx-auto max-w-96 lg:mt-8 lg:gap-y-8">
    <InfoBar
      v-if="loginChangeEmailError"
      variant="destructive"
      :title="t('common.error')"
      :message="t('changeEmail.fail')"
      @close="loginChangeEmailError = null"
    />
    <div v-if="loginChangeEmailData">
      <InfoBar
        variant="success"
        :title="t('common.success')"
        :message="t('changeEmail.success')"
        @close="loginChangeEmailData = null"
      />
      <div
        class="flex flex-wrap justify-center gap-2 bg-gradient-to-b from-background to-transparent pb-8 pt-4 text-sm text-primary lg:py-4"
      >
        <Button @click.stop="goToLogin">
          {{ t('changeEmail.login') }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { Base64 } from 'js-base64';
import { useAccountStore } from '@stores/account.store';
import { storeToRefs } from 'pinia';

import Button from '@ui/button/Button.vue';
import InfoBar from '@generics/InfoBar.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const accountStore = useAccountStore();
const { loginChangeEmailError, loginChangeEmailData } = storeToRefs(accountStore);

const goToLogin = () => {
  router.push({ name: 'Login' });
};

onMounted(async () => {
  // Get email from token
  const { token, ...query } = route.query;
  let email = '';

  if (token && typeof token === 'string' && token.includes('.')) {
    try {
      const [_, payloadBase64] = token.split('.');
      if (payloadBase64) {
        const payload = JSON.parse(Base64.decode(payloadBase64));
        email = payload.email;
      }
    } catch (error) {
      console.error('Failed to decode token:', error);
    }
  }

  if (!email) {
    router.push({ name: 'Login' });
    return;
  }

  await accountStore.loginChangeEmail(token as string, email);
  if (loginChangeEmailError.value) return;
  await router.replace({ query });
  accountStore.guestEmail = email;
});
</script>
